import React from 'react';
import { getEmojiAssetUrl } from '../../utils/emojiAssets';

interface EmojiIconProps {
  emoji: string;
  className?: string;
  label?: string;
}

const EmojiIcon: React.FC<EmojiIconProps> = ({ emoji, className = '', label }) => {
  const assetUrl = getEmojiAssetUrl(emoji);

  if (!assetUrl) {
    return <span className={className} role={label ? 'img' : undefined} aria-label={label} aria-hidden={label ? undefined : true}>{emoji}</span>;
  }

  return <img className={`inline-block object-contain ${className}`} src={assetUrl} alt={label ?? ''} aria-hidden={label ? undefined : true} draggable={false} />;
};

export default EmojiIcon;
